import React, { createContext, useContext, useState } from 'react';

const EntranceContext = createContext();

export const useEntrance = () => useContext(EntranceContext);

export const EntranceProvider = ({ children }) => {
    const [hasEntered, setHasEntered] = useState(false);

    return (
        <EntranceContext.Provider value={{ hasEntered, setHasEntered }}>
            {children}
        </EntranceContext.Provider>
    );
};
